'use strict';

var $ = require('jquery');

function updateDeliveryTime() {
    var $currentShippingMethod = $('.checkout-shipping-method-form').find('input:checked');
    var $deliveryTime = $('.sagawa-delivery-time');

    if ($currentShippingMethod.val() === 'STANDARD-DATE-JP') {
        $deliveryTime.show();
    } else {
        $deliveryTime.hide();
    }
}

exports.updateDeliveryTime = updateDeliveryTime;
